<template>
  <div id="consignmentView" v-if="this.ppadmin_data">
    <div v-html="consignmentInfo" class="img" style="overflow: hidden"></div>

    <div class="card">
      <button @click="toContactLine()">聯繫Line客服</button>
      <button @click="toShop()">查看寄倉商品</button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ConsignmentView",
  data() {
    return {};
  },
  computed: {
    ...mapState("home", ["websiteConfig", "homeInfo"]),
    ...mapState("headerNav", ["ppadmin_data"]),
    consignmentInfo() {
      return this.ppadmin_data[9].data;
    },
    category() {
      return this.homeInfo.NEW[4];
    },
  },
  mounted() {
    this.$store.state.toTopPosition = "5em";
  },
  beforeDestroy() {
    this.$store.state.toTopPosition =
      this.viewDevice == "mobile" ? "2em" : "5em";
  },
  methods: {
    toShop() {
      this.$router.push({
        path:
          "/category_list/" + this.category.cate_name + "/" + this.category.cid,
      });
    },
    toContactLine() {
      if (this.websiteConfig != null) {
        this.websiteConfig.company_info.forEach((element) => {
          if (element.key == "Line_Link") {
            window.open(element.value, "_blank");
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
#consignmentView {
  .mobile({
    ::v-deep img {
    width: 100%;
  }
  });

  .card {
    transition: all 0.2s linear;
    position: fixed;
    right: 30em;
    bottom: 2em;
    width: 30em;
    padding: 2em 0;
    border-radius: 05px 5px 5px 5px;
    background-color: rgba(255, 255, 255, 0.6);
    color: @primary-color;
    font-size: 0.8em;
    font-family: @font-family-bold;
    box-shadow: 0 0 4px 3px rgba(0, 0, 0, 0.1);
    button {
      cursor: pointer;
      transition: all 0.2s linear;
      font-family: @font-family-bold;
      border: 1px solid @primary-color;
      border-radius: 2em;
      width: 43%;
      height: 3em;
      margin: 0 0.5em;
      background-color: white;
      color: @primary-color;
      opacity: 0.9;
      &:hover {
        box-shadow: 0 0 4px 3px rgba(0, 0, 0, 0.1);
        opacity: 1;
      }
      &:nth-child(2) {
        background-color: @primary-color;
        color: white;
      }
    }
    &:hover {
      background-color: rgba(255, 255, 255, 0.9);
    }
    .mobile({
        width: 20em;
        bottom: 1em;
        right: 1em;
        padding: 1em 0;
    });
  }
}
</style>
